import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { showNewToMeWePopup } from 'mewe/utils/dialogs-common';
import { service } from '@ember/service';
import { installDropdown } from 'mewe/utils/dropdown-utils';

export default class ProfileMainAvatar extends Component {
  @service dynamicDialogs;

  @tracked dropdownOptions;

  constructor() {
    super(...arguments);
    installDropdown(this, 'dropdownOptions');
  }

  // Clone the contact object to avoid mutating the original object when a new contact is fetched
  get contact() {
    return JSON.parse(JSON.stringify(this.args.contact.__data));
  }

  @action
  userAvatarClick() {
    if (this.args.isPublicContent) {
      return showNewToMeWePopup(this.dynamicDialogs);
    }

    if (this.args.hasEntries) {
      // open dropdown, this function comes from the installDropdown function
      this.setDropdownRef?.(!this.dropdownOptions);
    } else {
      this.args.openProfilePhoto();
    }
  }

  @action
  openProfileStories() {
    this.args.openProfileStories();
  }

  @action
  openProfilePhoto() {
    this.args.openProfilePhoto();
  }
}
